import words from '../static/words.json'
import dict from '../static/dict.json'

export const getRandomWord = (): string => words[Math.floor(Math.random() * words.length)]

export const checkWord = (word: string): boolean => dict.includes(word)

export const checkGuess = (word: string, guess: string): string[] => {
  const guessArray = Array.from(guess.padEnd(word.length))
  const wordArray = Array.from(word)

  return guessArray.map((guessLetter, guessLetterIndex) => {
    if (guess.length < word.length) return '⬛️'

    const guessBehind = guessArray.slice(0, guessLetterIndex)

    const wordCorrectCount = wordArray.filter(
      (l, i) => l === guessLetter && l === guessArray[i]
    ).length
    const wordPresentCount = wordArray.filter((l) => l === guessLetter).length
    const guessBehindPresentCount = guessBehind.filter((l) => l === guessLetter).length
    const guessLetterCount = wordPresentCount - wordCorrectCount - guessBehindPresentCount

    const isCorrect = wordArray[guessLetterIndex] === guessLetter
    const isPresent = word.includes(guessLetter) && guessLetterCount > 0

    if (isCorrect) return '🟩'
    else if (isPresent) return '🟨'
    else return '⬛️'
  })
}
